const JobListEvents = {
  JOB_LIST_UNACTIONED_CLICKED: {
    name: "JOB_LIST_UNACTIONED_CLICKED",
    category: "JOB_LIST"
  },
  JOB_LIST_ACTIONED: {
    name: "JOB_LIST_ACTIONED",
    category: "JOB_LIST"
  },
  VIEW_ALL_CANDIDATES: {
    name: "VIEW_ALL_CANDIDATES",
    category: "JOB_LIST "
  },
  UNDER_REVIEW_VIEW_ALL_CANDIDATE_CLICKED: {
    name: "UNDER_REVIEW_VIEW_ALL_CANDIDATE_CLICKED",
    category: "JOB_LIST"
  },
  EDIT_JOB_CLICKED: {
    name: "EDIT_JOB_CLICKED",
    category: "JOB_LIST"
  },
  DASHBOARD_COMPLETE_DRAFT_CLICKED: {
    name: "DASHBOARD_COMPLETE_DRAFT_CLICKED",
    category: "JOB_LIST"
  },
  DASHBOARD_REPOST_JOB_CLICKED: {
    name: "DASHBOARD_REPOST_JOB_CLICKED",
    category: "JOB_LIST"
  },
  CLOSE_JOB_SUCCESS: {
    name: "CLOSE_JOB_SUCCESS",
    category: "JOB_LIST"
  },
  HIRING_NUDGE_RESPONSE: {
    name: "HIRING_NUDGE_RESPONSE",
    category: "JOB_LIST"
  },
  DATABASE_CLICKED: {
    name: "DATABASE_CLICKED",
    category: "JOB_LIST"
  },
  JOB_CARD_MENU_CLICKED: {
    name: "JOB_CARD_MENU_CLICKED",
    category: "JOB_LIST"
  },
  VIEW_HIRED_CANDIDATES: {
    name: "VIEW_HIRED_CANDIDATES",
    category: "JOB_LIST"
  },
  TAB_CHANGE: {
    name: "TAB_CHANGE",
    category: "JOB_LIST"
  },

  JOB_LIST_SHOWN: {
    name: "JOB_LIST_SHOWN",
    category: "JOB_LIST"
  },

  FILTER_APPLIED: {
    name: "FILTER_APPLIED",
    category: "JOB_LIST"
  },
  FILTER_CLEARED: {
    name: "FILTER_CLEARED",
    category: "JOB_LIST"
  },
  FILTER_OPTION_SELECTED: {
    name: "FILTER_OPTION_SELECTED",
    category: "JOB_LIST"
  },
  FILTER_OPTION_DESELECTED: {
    name: "FILTER_OPTION_DESELECTED",
    category: "JOB_LIST"
  },
  MOBILE_FILTER_OPENED: {
    name: "MOBILE_FILTER_OPENED",
    category: "JOB_LIST"
  },
  MOBILE_FILTER_APPLIED: {
    name: "MOBILE_FILTER_APPLIED",
    category: "JOB_LIST"
  },
  MOBILE_FILTER_CANCELLED: {
    name: "MOBILE_FILTER_CANCELLED",
    category: "JOB_LIST"
  },
  MOBILE_FILTER_RESET: {
    name: "MOBILE_FILTER_RESET",
    category: "JOB_LIST"
  }
};

export default JobListEvents;
